// extracted by mini-css-extract-plugin
export default {"root":"RegisterMode_root__7Ebxi","header":"RegisterMode_header__nWlYS","button":"RegisterMode_button__xE1Ww","active":"RegisterMode_active__T3jQC"};